import { render, staticRenderFns } from "./NavigationSidebarContent.vue?vue&type=template&id=4386b7a8&"
import script from "./NavigationSidebarContent.vue?vue&type=script&lang=js&"
export * from "./NavigationSidebarContent.vue?vue&type=script&lang=js&"
import style0 from "./NavigationSidebarContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports